import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Col,
  Table,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../components/RecordStatus";
import { taxGroupApi, taxGroupLabel, taxGroupStatic } from "./taxGroup.config";
import { elements } from "chart.js";

const { Text, Title } = Typography;
const {
  detailTaxGroupItems,
  monthList,
  transactionTypeData,
  viewTaxGroupBreadCrumbItems,
} = taxGroupStatic;

const columns = [
  {
    title: "Tax Component",
    dataIndex: "taxComponent",
  },
  {
    title: "Start date",
    dataIndex: "startDate",
  },
  {
    title: "End date",
    dataIndex: "endDate",
  },
];

const DetailTaxGroup = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [taxGroupDetail, setTaxGroupDetail] = useState([]);
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${taxGroupApi.taxGroup}/${state.id}?template=false`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempDetail = [];
        setIsLoading(false);

        setInputField([
          {
            name: taxGroupLabel.name,
            value: objDetail.name ? objDetail.name : "-",
          },
        ]);

        objDetail?.taxAssociations?.forEach((element) => {
          tempDetail.push({
            key: element?.id,
            id: element?.id,
            taxComponent: element?.taxComponent?.name,
            startDate: element?.startDate
              ? `${element?.startDate[2]} ${
                  monthList[element?.startDate[1] - 1]
                } ${element?.startDate[0]}`
              : "-",
            endDate: element?.endDate
              ? `${element?.endDate[2]} ${monthList[element?.endDate[1] - 1]} ${
                  element?.endDate[0]
                }`
              : "-",
          });
        });

        setTaxGroupDetail(objDetail?.taxAssociations);
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={taxGroupLabel.taxGroupDetail}
        pageItems={
          state.variant ? viewTaxGroupBreadCrumbItems : detailTaxGroupItems
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {taxGroupLabel.generalInfo}
              </Divider>
            </Row>
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={item.value}
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {taxGroupLabel.taxComponentInfo}
              </Divider>
            </Row>
            {taxGroupDetail.map((item, index) => (
              <Row key={index}>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{taxGroupLabel.taxComponent}</Text>}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={item.taxComponent.name}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{taxGroupLabel.startDate}</Text>}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={BOM.FormatArrayDate(item.startDate)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{taxGroupLabel.endDate}</Text>}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={
                        item.endDate
                          ? `${item?.endDate[2]} ${
                              monthList[item?.endDate[1] - 1]
                            } ${item?.endDate[0]}`
                          : "No End Date"
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}
            {/* <Table
              columns={columns}
              dataSource={taxGroupDetail}
              bordered
              pagination={{
                position: "bottomCentre",
              }}
            /> */}
          </Form>
        </Card>

        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailTaxGroup);
